document.addEventListener("click", function (event) {
  const target = event.target.closest(".subscription-selection-btn-sidebar");
  if (!target) return;

  const type = target.dataset.type;
  const form = target.dataset.form;
  const formElement = document.getElementById(form);

  if (!formElement) return;

  const subscriptionSelection = formElement.querySelector(
    `.subscription_selection #${type}`
  );

  if (subscriptionSelection?.classList.contains("active")) {
    return;
  }

  // Remove active class from all subscription selections
  const allSelections = formElement.querySelectorAll(".subscription_selection");
  allSelections.forEach((el) => el.classList.remove("active"));

  // Add active class to selected option container
  const optionsContainer = formElement.querySelector(
    `.product-subscription__options_container #${type}`
  );
  if (optionsContainer) {
    optionsContainer.classList.add("active");
  }

  // Remove selected class from all buttons
  const allButtons = formElement.querySelectorAll(
    ".subscription-selection-btn-sidebar"
  );
  allButtons.forEach((btn) => btn.classList.remove("selected"));

  // Add selected class to clicked button
  target.classList.add("selected");

  if (type === "subsave") {
    // Enable selling plan
    const sellingPlanInput = formElement.querySelector('[name="selling_plan"]');
    if (sellingPlanInput) {
      sellingPlanInput.disabled = false;
    }

    // Update price to subscription price
    const priceElement = formElement.querySelector("span[data-product-price]");
    const subscriptionPrice = formElement.querySelector(
      "span[data-subscription-discounted-price]"
    );
    if (priceElement && subscriptionPrice) {
      priceElement.textContent = subscriptionPrice.textContent;
    }

    // Show original price
    const originalPriceElements = document.querySelectorAll(".original_price");
    originalPriceElements.forEach((el) => (el.style.display = ""));
  } else {
    // Disable selling plan
    const sellingPlanInput = formElement.querySelector('[name="selling_plan"]');
    if (sellingPlanInput) {
      sellingPlanInput.disabled = true;
    }

    // Update price to original price
    const priceElement = formElement.querySelector("span[data-product-price]");
    const originalPrice = formElement.querySelector(
      "span[data-original-price]"
    );
    if (priceElement && originalPrice) {
      priceElement.textContent = originalPrice.textContent;
    }

    // Hide original price
    const originalPriceElements = document.querySelectorAll(".original_price");
    originalPriceElements.forEach((el) => (el.style.display = "none"));
  }
});

// Function to recreate modals with new product data
const recreateModals = (doc) => {
  try {
    // Find existing modals and remove them
    const existingModals = document.querySelectorAll(".barkco-modal");
    existingModals.forEach((modal) => {
      // Make sure this method is called before updating the product data.
      // meal-plan-modal is not from metafields so its removed here but then
      // recreated in the bindContractButtons function below via sectionsToUpdate logic.
      modal.remove();
    });

    // Extract and recreate modals from the new content
    const newModals = doc.querySelectorAll(".barkco-modal");
    newModals.forEach((newModal) => {
      // Don't recreate the meal plan calculator modal since it's not from metafields
      if (newModal.id !== "meal-plan-modal") {
        // Clone the modal and append to body
        const clonedModal = newModal.cloneNode(true);
        document.body.appendChild(clonedModal);
      }
    });

    // Re-initialize modal utility to bind events to new modals
    if (window.ModalUtility && window.ModalUtility.init) {
      window.ModalUtility.init();
    }
  } catch (error) {
    console.error("Error recreating modals:", error);
  }
};

const bindContractButtons = () => {
  const msContractButtons = document.querySelectorAll(
    "[data-ms-contract-button]"
  );

  if (msContractButtons.length > 0) {
    msContractButtons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();

        const url = button.getAttribute("href");
        window.history.pushState({}, "", url);

        const loading = document.querySelector("[data-product-info-loading]");
        loading.classList.add("show");

        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, "text/html");

        // Recreate modals with new product data
        recreateModals(doc);

        // Update product JSON data from new page content
        const newProductAmplitudeJson = doc.querySelector(
          "#productAmplitudeJson"
        );
        const newProductJson = doc.querySelector("#productJson");

        if (newProductAmplitudeJson) {
          const existingProductAmplitudeJson = document.querySelector(
            "#productAmplitudeJson"
          );
          if (existingProductAmplitudeJson) {
            existingProductAmplitudeJson.innerHTML =
              newProductAmplitudeJson.innerHTML;
          }
        }

        if (newProductJson) {
          const existingProductJson = document.querySelector("#productJson");
          if (existingProductJson) {
            existingProductJson.innerHTML = newProductJson.innerHTML;
          }

          // Update page title with new product title
          try {
            const productData = JSON.parse(newProductJson.innerHTML);
            if (productData.title) {
              document.title = productData.title;
            }
          } catch (error) {
            console.log("Error parsing product JSON for title update:", error);
          }
        }

        const sectionsToUpdate = [
          ".section--barkco-product-highlights",
          ".section--barkco-product-info",
          ".section--barkco-offer",
          ".shopify-section--dynamic-multi-column",
          ".section--barkco-faq",
          ".section--barkco-marquee",
          ".section--barkco-product-details-content",
          ".section--barkco-info-card",
          // Metaobject-driven dynamic sections (hero PDP, marquee, etc.) rendered above/below the buy box
          ".pdp-dynamic-sections--top",
          ".pdp-dynamic-sections--bottom"
        ];

        document.querySelector(".product-monthly-subscription").innerHTML =
          doc.querySelector(".product-monthly-subscription").innerHTML;

        // Update all sections that may be present. Use querySelectorAll (not querySelector) so
        // sections that appear more than once — e.g. a dynamic multi-column at both the top and
        // bottom of the PDP — all refresh. Match each instance to its counterpart in the fetched
        // doc by its stable shopify-section-{id}, so it stays correct even when a section is only
        // present on one of the two products.
        sectionsToUpdate.forEach((selector) => {
          document.querySelectorAll(selector).forEach((targetSection) => {
            const sourceSection = targetSection.id
              ? doc.getElementById(targetSection.id)
              : doc.querySelector(selector);
            if (sourceSection) {
              targetSection.innerHTML = sourceSection.innerHTML;
            }
          });
        });

        bindContractButtons();
        lucide.createIcons();

        loading.classList.remove("show");

        // Dispatch event to notify that loading state has changed
        document.dispatchEvent(new CustomEvent("loadingStateChanged"));
      });
    });
  }
};

bindContractButtons();

const scrollbarContainer = document.querySelector(
  ".dsgn-pck__link-menu-icons .fc-scrollbar-container"
);
const scrollbarProgress = document.querySelector(
  ".dsgn-pck__link-menu-icons .fc-scroll-progress"
);

function updateScrollbar() {
  const windowWidth = window.innerWidth;
  let featuredCollectionContainer = document.querySelector(
    ".dsgn-pck__link-menu-icons .dsgn-pck__sizer"
  );
  if (windowWidth <= 480) {
    featuredCollectionContainer = document.querySelector(
      ".dsgn-pck__link-menu-icons .dsgn-pck__sizer ul"
    );
  }
  const contentWidth = featuredCollectionContainer.scrollWidth;
  const containerWidth = scrollbarContainer.offsetWidth;
  const scrollWidth = (containerWidth / contentWidth) * 100;
  scrollbarProgress.style.width = `${scrollWidth}%`;
  featuredCollectionContainer.addEventListener(
    "scroll",
    updateScrollbarProgress
  );
}

function updateScrollbarProgress() {
  const windowWidth = window.innerWidth;
  let featuredCollectionContainer = document.querySelector(
    ".dsgn-pck__link-menu-icons .dsgn-pck__sizer"
  );
  let blankSpace = 5;
  if (windowWidth <= 480) {
    featuredCollectionContainer = document.querySelector(
      ".dsgn-pck__link-menu-icons .dsgn-pck__sizer ul"
    );
    blankSpace = 1;
  }
  const contentWidth = featuredCollectionContainer.scrollWidth;
  const contentScroll = featuredCollectionContainer.scrollLeft;
  const containerWidth = scrollbarContainer.offsetWidth;
  const scrollWidth = ((containerWidth + contentScroll) / contentWidth) * 100;
  scrollbarProgress.style.width = `${scrollWidth + blankSpace}%`;
}

if (scrollbarContainer && scrollbarProgress) {
  document.addEventListener("DOMContentLoaded", updateScrollbar);
  window.addEventListener("resize", updateScrollbar);
}
